import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form';
import { toFromDates, convertUtcDate } from '../components/Common/cleanDates';

import {
  REQUEST_INVENTORY_ADJUSTMENTS,
  FETCH_INVENTORY_ADJUSTMENTS_SUCCESS,
  FETCH_INVENTORY_ADJUSTMENTS_FAILURE,
  REQUEST_INVENTORY_ADJUSTMENTS_DETAIL,
  FETCH_INVENTORY_ADJUSTMENTS_DETAIL_SUCCESS,
  FETCH_INVENTORY_ADJUSTMENTS_DETAIL_FAILURE,
  SELECT_INVENTORY_ADJUSTMENT,
  RESET_CURRENT_INVENTORY_ADJUSTMENT,
  REQUEST_INVENTORY_ADJUSTMENT_DETAIL,
  FETCH_INVENTORY_ADJUSTMENT_DETAIL_SUCCESS,
  FETCH_INVENTORY_ADJUSTMENT_DETAIL_FAILURE,
  REQUEST_CREATING_INVENTORY_ADJUSTMENTS,
  CREATE_INVENTORY_ADJUSTMENTS_SUCCESS,
  CREATE_INVENTORY_ADJUSTMENTS_FAILURE,
  REQUEST_EDITING_INVENTORY_ADJUSTMENTS,
  EDIT_INVENTORY_ADJUSTMENTS_SUCCESS,
  EDIT_INVENTORY_ADJUSTMENTS_FAILURE,
  REQUEST_QUICK_INVENTORY_ADJUSTMENTS,
  QUICK_INVENTORY_ADJUSTMENTS_SUCCESS,
  QUICK_INVENTORY_ADJUSTMENTS_FAILURE,
  RESET_QUICK_INVENTORY_ADJUSTMENTS,
} from './type';

import {
  INVENTORY_ADJUSTMENTS_URL,
  QUICK_INVENTORY_ADJUSTMENTS_URL,
} from './url';

import { DEFAULT_ERROR } from '../components/Common/constants';

// InventoryAdjustments Actions

export function fetchInventoryAdjustments() {
  return (dispatch) => {
    dispatch({ type: REQUEST_INVENTORY_ADJUSTMENTS });
    return axios.get(
      INVENTORY_ADJUSTMENTS_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchInventoryAdjustmentsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchInventoryAdjustmentsFailure(err));
      });
  };
}

export function fetchInventoryAdjustmentsSuccess(inventoryAdjustments) {
  return {
    type: FETCH_INVENTORY_ADJUSTMENTS_SUCCESS,
    payload: inventoryAdjustments,
  };
}

export function fetchInventoryAdjustmentsFailure(error) {
  return {
    type: FETCH_INVENTORY_ADJUSTMENTS_FAILURE,
    payload: error,
  };
}

export function fetchInventoryAdjustmentsDetail(id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_INVENTORY_ADJUSTMENTS_DETAIL });
    return axios.get(
      `${INVENTORY_ADJUSTMENTS_URL}?pk=${id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchInventoryAdjustmentsDetailSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchInventoryAdjustmentsDetailFailure(err));
      });
  };
}

export function fetchInventoryAdjustmentsDetailSuccess(data) {
  return {
    type: FETCH_INVENTORY_ADJUSTMENTS_DETAIL_SUCCESS,
    payload: data,
  };
}

export function fetchInventoryAdjustmentsDetailFailure(error) {
  return {
    type: FETCH_INVENTORY_ADJUSTMENTS_DETAIL_FAILURE,
    payload: error,
  };
}

export function selectInventoryAdjustment(inventoryAdjustment) {
  return {
    type: SELECT_INVENTORY_ADJUSTMENT,
    payload: inventoryAdjustment,
  };
}

export function resetCurrentInventoryAdjustment() {
  return {
    type: RESET_CURRENT_INVENTORY_ADJUSTMENT,
  };
}


export function fetchInventoryAdjustmentDetail(inventoryAdjustment_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_INVENTORY_ADJUSTMENT_DETAIL });
    return axios.get(
      INVENTORY_ADJUSTMENTS_URL + inventoryAdjustment_id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchInventoryAdjustmentDetailSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchInventoryAdjustmentDetailFailure(err));
      });
  };
}

export function fetchInventoryAdjustmentDetailSuccess(inventoryAdjustmentDetail) {
  inventoryAdjustmentDetail = inventoryAdjustmentDetail.data;
  if (inventoryAdjustmentDetail.PostingDate) inventoryAdjustmentDetail.PostingDate = convertUtcDate(inventoryAdjustmentDetail.PostingDate);
  return {
    type: FETCH_INVENTORY_ADJUSTMENT_DETAIL_SUCCESS,
    payload: inventoryAdjustmentDetail,
  };
}

export function fetchInventoryAdjustmentDetailFailure(error) {
  return {
    type: FETCH_INVENTORY_ADJUSTMENT_DETAIL_FAILURE,
    payload: error,
  };
}

export function createInventoryAdjustment(
  Warehouse_id,
  PostingDate,
  Note,
  Warehouse_Adjustment_Line,
) {
  if (PostingDate) PostingDate = convertUtcDate(PostingDate);
  return (dispatch) => {
    dispatch({ type: REQUEST_CREATING_INVENTORY_ADJUSTMENTS });
    axios.post(
      INVENTORY_ADJUSTMENTS_URL,
      {
        Warehouse_id,
        PostingDate,
        Note,
        Warehouse_Adjustment_Line,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(createInventoryAdjustmentSuccess());
        browserHistory.push('/inventories/adjustment');
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(createInventoryAdjustmentFailure(err));
      });
  };
}

export function createInventoryAdjustmentSuccess() {
  return {
    type: CREATE_INVENTORY_ADJUSTMENTS_SUCCESS,
  };
}

export function createInventoryAdjustmentFailure(error) {
  return {
    type: CREATE_INVENTORY_ADJUSTMENTS_FAILURE,
    payload: error,
  };
}

export function editInventoryAdjustment(
  WarehouseAdjustment_id,
  Warehouse_id,
  PostingDate,
  Note,
  Warehouse_Adjustment_Line,
) {
  if (PostingDate) PostingDate = convertUtcDate(PostingDate);
  if (Warehouse_Adjustment_Line) {
    Warehouse_Adjustment_Line.map((line) => {
      line.WarehouseBin_id = line.WarehouseBin_id.WarehouseBin_id;
      line.WarehouseZone_id = line.WarehouseZone_id.WarehouseZone_id;
    });
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_EDITING_INVENTORY_ADJUSTMENTS });
    axios.put(
      INVENTORY_ADJUSTMENTS_URL + WarehouseAdjustment_id,
      {
        Warehouse_id,
        PostingDate,
        Note,
        Warehouse_Adjustment_Line,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(editInventoryAdjustmentSuccess());
        browserHistory.push('/inventories/adjustment');
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(editInventoryAdjustmentFailure(err));
      });
  };
}

export function editInventoryAdjustmentSuccess() {
  return {
    type: EDIT_INVENTORY_ADJUSTMENTS_SUCCESS,
  };
}

export function editInventoryAdjustmentFailure(error) {
  return {
    type: EDIT_INVENTORY_ADJUSTMENTS_FAILURE,
    payload: error,
  };
}

export function quickAdjustment(
  {
    ProductNum,
    Warehouse_id,
  },
  Warehouse_Adjustment_Line,
) {
  return (dispatch) => {
    dispatch({ type: REQUEST_QUICK_INVENTORY_ADJUSTMENTS });
    axios.post(
      QUICK_INVENTORY_ADJUSTMENTS_URL,
      {
        ProductNum,
        Warehouse_id,
        Warehouse_Adjustment_Line,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(quickAdjustmentSuccess());
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(quickAdjustmentFailure(err));
      });
  };
}

export function quickAdjustmentSuccess() {
  return {
    type: QUICK_INVENTORY_ADJUSTMENTS_SUCCESS,
  };
}

export function quickAdjustmentFailure(error) {
  return {
    type: QUICK_INVENTORY_ADJUSTMENTS_FAILURE,
    payload: error,
  };
}

export function resetQuickInventoryAdjustments() {
  return {
    type: RESET_QUICK_INVENTORY_ADJUSTMENTS,
  };
}



// WEBPACK FOOTER //
// ./master/jsx/actions/inventoryAdjustments_actions.js